module.exports = __webpack_public_path__ + "static/media/newsletter.944bc0af.svg";